import React from 'react';
import './Sidebar.css';
import { Avatar } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUser } from './features/userSlice';

function Sidebar() {
  const user = useSelector(selectUser);
  const recentItem = (topic) => {
    return (<div className='sidebar_recentItem'>
      <span className='sidebar_hash'>#</span>
      <p>{topic}</p>
    </div>);
  };

  return (
    <div className='sidebar'>
      <div className='sidebar_top'>
        <img src='https://images.pexels.com/photos/7130469/pexels-photo-7130469.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' alt=''/>
        <Avatar src={user.photoUrl!==null ? user.photoUrl : ""} className='sidebar_avatar'>
          {user.displayName!==null ? user.displayName[0] : ""}
        </Avatar>
        <h2>{user.displayName}</h2>
        <h4>{user.email}</h4>
      </div>
      <div className='sidebar_stats'>
        <div className='sidebar_stat'>
          <p>Who viewed you</p>
          <p className='sidebar_statNumber'>2,538</p>
        </div>
        <div className='sidebar_stat'>
          <p>Viwes on post</p>
          <p className='sidebar_statNumber'>2,538</p>
        </div>
      </div>

      <div className='sidebar_bottom'>
        <p>Recent</p>
        {recentItem('rockets')}
        {recentItem('mars')}
        {recentItem('boxing')}
        {recentItem('zuck')}
        {recentItem('winning')}
      </div>
    </div>
  );
}

export default Sidebar